export function initCounterAnimation(): void {
    const counters: NodeListOf<HTMLElement> = document.querySelectorAll('.counter-target');

    function getDecimalPlaces(num: number): number {
        const str = num.toString();
        if (str.includes('.')) {
            return str.split('.')[1].length;
        }
        return 0;
    }

    function isVisible(el: HTMLElement): boolean {
        const rect = el.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
    }

    function animate(el: HTMLElement): void {
        const target = parseFloat(el.dataset.target || '0');
        const duration = parseInt(el.dataset.duration || '1500', 10);
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const decimalPlaces = getDecimalPlaces(target);
        let startTime: number | null = null;

        function update(timestamp: number): void {
            if (!startTime) {
                startTime = timestamp;
            };
            const progress = timestamp - startTime;
            const percent = Math.min(progress / duration, 1);
            const currentValue = percent * target;
            let displayValue: string;

            if (decimalPlaces > 0) {
                displayValue = currentValue.toFixed(decimalPlaces);
            } else {
                displayValue = Math.floor(currentValue).toLocaleString();
            }

            el.textContent = `${prefix}${displayValue}${suffix}`;

            if (percent < 1) {
                requestAnimationFrame(update);
            }
        }

        requestAnimationFrame(update);
        el.classList.add('counted');
    }

    function checkCounters(): void {
        counters.forEach(counter => {
            if (!counter.classList.contains('counted') && isVisible(counter)) {
                animate(counter);
            }
        });
    }

    window.addEventListener('scroll', checkCounters);
}